import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  helperText: {
    margin: '10px 0 0 0',
  },
  actionsContainer: {
    padding: '0 24px',
  },
  accordionDetails: {
    maxHeight: 220,
    overflow: 'auto',
  },
  listItem: {
    paddingLeft: 3,
  },
  failed: {
    color: '#D42F42',
  },
  clearText: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  charactersLeft: {
    color: theme.palette.grey[100],
    fontSize: 14,
  },
  participantNameGridItem: {
    alignSelf: 'center',
  },
  recipientContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  charactersLeftContainer: {
    marginTop: 10,
  },
  clearTextStaff: {
    color: '#427fc0',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  warningContainer: {
    width: '100%',
    backgroundColor: '#fffbed',
    marginTop: 15,
    marginBottom: 15,
    border: '1px solid #dd9d3b',
    borderRadius: 4,
  },
  warningWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 0,
  },
  warningIcon: {
    paddingRight: 5,
  },
  warningText: {
    paddingTop: 10,
    paddingBottom: 10,
  },
}));
